// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"ImageElement_innerWrapper__3ZXf8","image":"ImageElement_image__il9YE","hidden":"ImageElement_hidden__BA6IP","absolute":"ImageElement_absolute__3q6Mu"};